import React from 'react'

import { MenuItem } from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'

import { startExportStaff } from '../../../redux/features/staffSlice'
import { ExportLoading } from '../../ui'

const StaffActionMenu = () => {
  const dispatch = useDispatch()
  const isExporting = useSelector(state => state.staff.exporting)

  return (
    <>
      <MenuItem
        onClick={() => dispatch(startExportStaff({ useFilters: true }))}
      >
        Export current view
      </MenuItem>
      <ExportLoading isLoading={isExporting} />
    </>
  )
}

export default StaffActionMenu
